import { User } from 'oidc-client-ts'

const TOKEN_KEY = `oidc.user:${process.env.REACT_APP_OIDC_AUTHORITY}:${process.env.REACT_APP_OIDC_CLIENT_ID}`

export const getUser = () => {
    const oidcStorage = sessionStorage.getItem(TOKEN_KEY)

    if (!oidcStorage) return null

    return User.fromStorageString(oidcStorage)
}